/* Selten Fleet — theme JS
 * - Mobile menu toggle
 * - Inventory quick search redirect
 * - Scroll reveals (with IntersectionObserver)
 * - Form loading states
 * - Honeypot spam protection
 * - Smooth scroll for anchor links
 */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;

  // ── Mobile menu toggle (fallback) ────────────────────────────────────
  var header = document.querySelector('.site-header');
  var toggle = document.querySelector('.site-header__menu-toggle');
  if (toggle && header && !toggle.dataset.bound) {
    toggle.dataset.bound = '1';
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('site-header--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ── Inventory quick search ───────────────────────────────────────────
  var searchForm = document.querySelector('[data-inventory-search]');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(searchForm);
      var params = new URLSearchParams();
      var type = fd.get('type'), year = fd.get('year'), location = fd.get('location');
      if (type) params.append('filter.p.m.specs.equipment_type', type);
      if (year) params.append('filter.p.m.specs.year', year);
      if (location) params.append('filter.p.m.specs.location', location);
      var baseUrl = searchForm.getAttribute('data-target') || '/collections/all';
      window.location.href = baseUrl + (params.toString() ? '?' + params.toString() : '');
    });
  }

  // ── Scroll reveal ────────────────────────────────────────────────────
  if ('IntersectionObserver' in window && !prefersReduced) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ── Honeypot spam protection ─────────────────────────────────────────
  document.querySelectorAll('form[action*="contact"]').forEach(function (form) {
    if (form.querySelector('[name="contact[company_website]"]')) return;
    var hp = document.createElement('div');
    hp.style.cssText = 'position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden;';
    hp.setAttribute('aria-hidden', 'true');
    hp.innerHTML = '<label>Website (do not fill)<input type="text" name="contact[company_website]" tabindex="-1" autocomplete="off"></label>';
    form.appendChild(hp);
    form.addEventListener('submit', function (e) {
      var trap = form.querySelector('[name="contact[company_website]"]');
      if (trap && trap.value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  });

  // ── Form loading states ──────────────────────────────────────────────
  document.querySelectorAll('form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!btn) return;
      btn.dataset.originalText = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Enviando...';
      setTimeout(function () {
        if (btn.getAttribute('aria-busy') === 'true') {
          btn.removeAttribute('aria-busy');
          if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
        }
      }, 8000);
    });
  });

  // ── Smooth scroll for anchor links ───────────────────────────────────
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (href === '#' || href.length < 2) return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({
      behavior: prefersReduced ? 'auto' : 'smooth',
      block: 'start'
    });
    setTimeout(function () {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, 400);
  });

  // ── Auto reveal on common section roots (progressive enhancement) ────
  var autoSel = ['.bento', '.ftl', '.hiw', '.cs', '.contact-page__hero',
                 '.contact-benefit', '.value-card'];
  autoSel.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-visible');
    });
  });

})();
